/* tslint:disable */
/* eslint-disable */
/**
 * Brandside Backend API
 * REST API бэкенда Brandside. Авторизация — Bearer-токен Laravel Passport (заголовок Authorization: Bearer token). Успешные ответы оборачиваются в конверт success_response — status: true, data: ...; ошибки — common_error_response — status: false, errors._common: сообщение.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime'
/**
 *
 * @export
 * @interface ShowCryptoLink200Response
 */
export interface ShowCryptoLink200Response {
  /**
   *
   * @type {boolean}
   * @memberof ShowCryptoLink200Response
   */
  status: boolean
  /**
   * Расшифрованный payload шифрованной ссылки — произвольный JSON, зашитый при создании
   * @type {{ [key: string]: any; }}
   * @memberof ShowCryptoLink200Response
   */
  data: { [key: string]: any }
}

/**
 * Check if a given object implements the ShowCryptoLink200Response interface.
 */
export function instanceOfShowCryptoLink200Response(
  value: object
): value is ShowCryptoLink200Response {
  if (!('status' in value) || value['status'] === undefined) return false
  if (!('data' in value) || value['data'] === undefined) return false
  return true
}

export function ShowCryptoLink200ResponseFromJSON(
  json: any
): ShowCryptoLink200Response {
  return ShowCryptoLink200ResponseFromJSONTyped(json, false)
}

export function ShowCryptoLink200ResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): ShowCryptoLink200Response {
  if (json == null) {
    return json
  }
  return {
    status: json['status'],
    data: json['data'],
  }
}

export function ShowCryptoLink200ResponseToJSON(
  value?: ShowCryptoLink200Response | null
): any {
  if (value == null) {
    return value
  }
  return {
    status: value['status'],
    data: value['data'],
  }
}
